import React from 'react';
import Step4AccessRights from '../Company/Employees/EnrollmentSteps/Step4AccessRights';
import NotInformation from '../../../components/NotInformation';
import ContractorAccessRightsApp from "./Functionality/ContractorAccessRightsApp";
import HeadTittle from "../../../components/HeadTittle";
import DivContainerBody from "../../../components/DivContainerBody";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const AccessRights = ({userType}) => {
    const {t, workShiftsList, setWorkShiftsList, customizedList, setCustomizedList} = ContractorAccessRightsApp();

    return (
        <>
            <HeadTittle name={'access_rights'}/>
            <DivContainerBody>
                {workShiftsList.length > 0 || customizedList.length > 0 ? (
                    <Step4AccessRights
                        workShiftsList={workShiftsList}
                        setWorkShiftsList={setWorkShiftsList}
                        customizedList={customizedList}
                        setCustomizedList={setCustomizedList}
                        userType={userType}
                        cardContentClass={'h-82vh'}
                    />
                ) : (
                    <NotInformation text={t('no_information')} card={true} />
                )}
            </DivContainerBody>
        </>
    );
};

export default AccessRights;
